<div class="dashboard-container">
  <!-- Header -->
  <div class="dashboard-header">
    <h2>AMC Management Dashboard</h2>
    <div class="header-actions">
      <button class="action-button primary" (click)="showAddAMCModal()">
        <i class="fas fa-plus"></i> Add New AMC
      </button>
      
      <!-- Download Report Dropdown -->
      <div class="dropdown">
        <button class="action-button" (click)="toggleDownloadDropdown()">
          <i class="fas fa-download"></i> Download Report <i class="fas fa-chevron-down dropdown-arrow"></i>
        </button>
        <div class="dropdown-menu" [class.show]="showDownloadDropdown">
          <button class="dropdown-item" (click)="downloadReport('excel')">Excel</button>
          <button class="dropdown-item" (click)="downloadReport('pdf')">PDF</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Stats Cards -->
  <div class="stats-grid">
    <div class="stat-card expired" (click)="filterByStatus('expired')">
      <div class="stat-title">Expired AMCs</div>
      <div class="stat-value">{{ getExpiredCount() }}</div>
    </div>
    <div class="stat-card warning" (click)="filterByStatus('warning')">
      <div class="stat-title">Expiring Soon</div>
      <div class="stat-value">{{ getExpiringSoonCount() }}</div>
    </div>
    <div class="stat-card active" (click)="filterByStatus('active')">
      <div class="stat-title">Active AMCs</div>
      <div class="stat-value">{{ getActiveCount() }}</div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="content-area">
    <!-- Search and Filters -->
    <div class="search-bar">
      <div class="search-input">
        <i class="fas fa-search"></i>
        <input 
          type="text" 
          [(ngModel)]="searchTerm" 
          (input)="applyFilters()" 
          placeholder="Search by Device ID or Transformer ID"
        >
      </div>
      <div class="filter-dropdown">
        <select [(ngModel)]="statusFilter" (change)="applyFilters()">
          <option value="all">All Status</option>
          <option value="expired">Expired</option>
          <option value="warning">Expiring Soon</option>
          <option value="active">Active</option>
        </select>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Device ID</th>
            <th>Transformer ID</th>
            <th>Customer</th>
            <th>Renewal Date</th>
            <th>AMC Period</th>
            <th>Status</th>
            <th>Expiry Date</th>
            <th>Expiry Info</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let amc of paginatedItems" [ngClass]="{'expired-row': getAMCStatus(amc) === 'expired', 'warning-row': getAMCStatus(amc) === 'warning'}">
            <td>{{ amc.device_id }}</td>
            <td>{{ amc.transformer_id }}</td>
            <td>{{ amc.customer == null ? 'No name provided' : (amc.customer === '' ? 'No name provided' : amc.customer) }}</td>
            <td>
              <div class="date-cell">
                <input 
                  type="date" 
                  [(ngModel)]="amc.renewal_date" 
                  class="date-input-hidden"
                  (change)="onRenewalDateChange(amc)"
                >
                <span class="date-display">{{ formatDate(amc.renewal_date) }}</span>
                 <i class="fas fa-calendar-alt date-picker-icon"></i>
              </div>
            </td>
            <td>
              <input 
                type="number" 
                [(ngModel)]="amc.amc_period" 
                class="form-control"
                (change)="onAMCPeriodChange(amc)"
                min="0"
              >
            </td>
            <td>
              <span class="status-badge" [ngClass]="getAMCStatus(amc)">
                {{ getAMCStatus(amc) | titlecase }}
              </span>
            </td>
            <td>
              {{ formatDate(getExpiryDate(amc)) }}
            </td>
            <td>
              <span class="expiry-info" [ngClass]="getAMCStatus(amc)">
                {{ getDaysUntilExpiry(amc) }}
              </span>
            </td>
            <td>
              <button 
                class="action-button edit"
                (click)="showEditModal(amc)"
              >
                <i class="fas fa-edit"></i> Edit
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="pagination">
      <button 
        [disabled]="currentPage === 1"
        (click)="changePage(currentPage - 1)"
      >
        <i class="fas fa-chevron-left"></i> Previous
      </button>

      <span class="page-info">Page {{currentPage}} of {{totalPages}}</span>
      
      <button 
        *ngFor="let page of pagesToDisplay"
        [class.active]="currentPage === page"
        (click)="changePage(page)"
      >
        {{ page }}
      </button>
      
      <button 
        [disabled]="currentPage === totalPages"
        (click)="changePage(currentPage + 1)"
      >
        Next <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
</div>

<!-- Edit Modal -->
<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ editingAMC ? 'Edit AMC' : 'Add New AMC' }}</h3>
      <button class="close-button" (click)="closeModal()">×</button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Device ID</label>
        <select class="form-control" [(ngModel)]="editingAMC.device_id" (change)="onDeviceChange()">
          <option *ngIf="editingAMC.device_id " [value]="editingAMC.device_id">
            {{ editingAMC.device_id }}
          </option>
        
          <option *ngFor="let device of deviceList" [value]="device.deviceId || device.device_id">
            {{ device.deviceId || device.device_id }}
          </option>
        </select>
             
      </div>
      
      <div class="form-group">
        <label>Transformer ID</label>
        <input type="text" [(ngModel)]="editingAMC.transformer_id" readonly>
      </div>
      <div class="form-group">
        <label>Customer</label>
        <input type="text" [(ngModel)]="editingAMC.customer">
      </div>
      <div class="form-group">
        <label>Renewal Date</label>
        <input type="date" [(ngModel)]="editingAMC.renewal_date" >
      </div>
      <div class="form-group">
        <label>AMC Period (Years)</label>
        <input type="number" [(ngModel)]="editingAMC.amc_period" min="0">
      </div>
      <div class="form-group">
        <label>
          <input type="checkbox" [(ngModel)]="editingAMC.dashboard_access" [checked]="editingAMC.dashboard_access === 1">
          Dashboard Access
        </label>
      </div>
    </div>
    <div class="modal-footer">
      <button class="action-button" (click)="closeModal()">Cancel</button>
      <button class="action-button edit" (click)="saveAMC()">Save Changes</button>
    </div>
  </div>
</div>

<!-- Toast Notification -->
<div class="toast" *ngIf="showToast" [ngClass]="toastType">
  <i class="fas" [ngClass]="{
    'fa-check-circle': toastType === 'success',
    'fa-exclamation-circle': toastType === 'warning',
    'fa-times-circle': toastType === 'error'
  }"></i>
  <span>{{ toastMessage }}</span>
</div>
